import { getApiBase } from '../apiBase';
import { getTenantHeaders } from '../api';
import { safeJson } from './calendarApi';

const BASE = getApiBase();
const RECURRING_APPOINTMENTS_API = `${BASE}/api/appointments/recurring`;

export const previewRecurringDates = async (payload) => {
  const res = await fetch(`${RECURRING_APPOINTMENTS_API}/date-preview`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...getTenantHeaders() },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const data = await safeJson(res);
    throw new Error(data?.error || `preview recurring dates ${res.status}`);
  }

  return await safeJson(res);
};

export const previewRecurringAppointments = async (payload) => {
  const res = await fetch(`${RECURRING_APPOINTMENTS_API}/preview`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...getTenantHeaders() },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`preview recurring appointments ${res.status} ${txt}`);
  }

  return await safeJson(res);
};

export const createRecurringAppointments = async (payload) => {
  const res = await fetch(RECURRING_APPOINTMENTS_API, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...getTenantHeaders() },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`create recurring appointments ${res.status} ${txt}`);
  }

  return await safeJson(res);
};

export const deleteRecurringFuture = async (selectedAppointmentId) => {
  const res = await fetch(
    `${BASE}/api/appointments/${selectedAppointmentId}/recurring-future`,
    {
      method: "DELETE",
      headers: { ...getTenantHeaders() },
    }
  );

  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`delete recurring future ${res.status} ${txt}`);
  }

  return await safeJson(res);
};

export const fetchRecurringSeries = async (selectedAppointmentId, { signal } = {}) => {
  const res = await fetch(
    `${BASE}/api/appointments/${selectedAppointmentId}/recurring-series`,
    {
      headers: { ...getTenantHeaders() },
      signal,
    }
  );

  if (!res.ok) {
    const data = await safeJson(res);
    throw new Error(data?.error || `load recurring series ${res.status}`);
  }

  const data = await safeJson(res);
  return Array.isArray(data?.appointments) ? data.appointments : [];
};
